import React from 'react';
import Product from './Product';


export default class ProductList extends React.PureComponent {
  render() {
    const {products, related, horizontal} = this.props;

    return products.map(product => (
      <Product
        horizontal={horizontal}
        related={related}
        key={product.code}
        slug={product.slug}
        name={product.name}
        label={product.promotionLabel}
        image={product.images[0]}
        price={product.price}
      />
    ));
  }
}



// WEBPACK FOOTER //
// ./components/product/ProductList.js